import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const StorySection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800&auto=format&fit=crop"
                alt="MyNewFloor showroom interior"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Accent badge */}
            <div className="absolute -bottom-6 -right-6 bg-primary text-primary-foreground p-6 rounded-2xl shadow-lg hidden md:block">
              <div className="text-center">
                <span className="block text-4xl font-bold">14+</span>
                <span className="text-sm">Years Serving<br />Charlotte</span>
              </div>
            </div>
          </motion.div>

          {/* Right Column - Content */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-primary font-semibold text-sm uppercase tracking-wider">
              Welcome to MyNewFloor.com
            </span>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-foreground mt-2 mb-6">
              Charlotte's Premier Flooring Company
            </h2>
            <p className="text-muted-foreground text-lg mb-6">
              Whether it's wood, vinyl, tile, or carpet, our design-focused staff and certified 
              installers work with you to provide the perfect flooring for your home and budget.
            </p>
            <p className="text-muted-foreground mb-8">
              We believe getting new floors should be simple, transparent, and stress-free. 
              That's why we created an all-inclusive pricing model that covers everything — 
              materials, installation, demolition, and more — with no hidden fees or surprises.
            </p>

            {/* Key Points */}
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-semibold text-foreground">All-Inclusive Pricing</h4>
                  <p className="text-sm text-muted-foreground">
                    Materials, installation, demolition, underlayment, transitions, and tax — all included.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-semibold text-foreground">Certified Installers Only</h4>
                  <p className="text-sm text-muted-foreground">
                    Every project is completed by highly trained, licensed professionals.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-semibold text-foreground">Three Convenient Locations</h4>
                  <p className="text-sm text-muted-foreground">
                    Showrooms in South Charlotte and Lake Norman, plus our Charlotte warehouse.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
